import React from 'react'
import { Row, Col } from 'react-bootstrap'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IHomeData, IRoomTypeData } from '../../types/api/homeApi';
import { NoData } from '../common/NoData';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const Room: React.FC<{ room_types: Array<IRoomTypeData>, home_data: IHomeData }> = ({ room_types, home_data }) => {

    const {t} = useTranslation()
    const room_types_json = t('room_suite.rooms', { returnObjects: true })  as IRoomTypeData[];

    console.log(room_types_json[0],"room_types_json");
    
    const roomSlider = {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        arrows: false,
        dots: true,
        speed: 300,
        centerPadding: '10px',
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1149,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    dots: true,
                    centerPadding: '20px'
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerMode: true,
                    dots: true,
                    centerPadding: '20px'
                }
            },
            {
                breakpoint:799,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    dots: true,
                    centerPadding: '20px'
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    dots:true,
                    centerPadding: '0px'
                }
            }
        ]
    };

    return (
        <section className='room'>
            <Row className='align-items-center'>
                <Col md={12} lg={4}>
                    <div className='room-box'>
                        <h4 className='title-highlight'>{t('home.room.hotel_name')}</h4>
                        <h3>{t('home.room.title')}</h3>
                        <p>{t('home.room.description')}</p>
                        <Link to={home_data && home_data.rooms_description && home_data.rooms_description.link} className='btn btn-black'>{t('home.about_us.read_more')}</Link>
                    </div>
                </Col>
                <Col md={12} lg={8}>
                    <Slider {...roomSlider}>
                        {
                            room_types && room_types.length > 0 ?
                                room_types.map((room_type: IRoomTypeData, index: number) => (
                                    <div className='room-details' key={'popular_rooms_' + index} >
                                        <div className='room-images'>
                                            <img src={require('../../assets/images/room-01.jpg')} alt='demo' />
                                            <div className='overlay-2'></div>
                                        </div>
                                        <div className='room-info'>
                                            <div className='star'>
                                                <ul>
                                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                                </ul>
                                            </div>
                                            <h5>{room_types_json && room_types_json.length>0 &&  room_types_json[index].name}</h5>
                                            <p>{room_types_json && room_types_json.length>0 && room_types_json[index].description}</p>
                                            <div className='price'>
                                                <h3>$ {room_types_json && room_types_json.length>0 && room_types_json[index].base_price} / {t('room_suite.night')}</h3>
                                                <p>{t('room_suite.person')} : {room_types_json && room_types_json.length>0 && room_types_json[index].total_person}</p>
                                            </div>
                                            <Link to={room_type.link} className='btn btn-gold'>{t('home.hero_section.book_now')}</Link>
                                        </div>
                                    </div>
                                ))
                                : <NoData message="Oops!! No room types found." />
                        }
                    </Slider>
                </Col>
            </Row>
        </section >
    )
}

export default Room;
